{
document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    const sliders = document.querySelectorAll(".womenResultSlider");
    sliders.forEach((slider, index) => {
      requestAnimationFrame(() => {
        new Swiper(slider, {
          direction: "horizontal",
          loop: true,
          speed: 1300, 
          centeredSlides: true,
          grabCursor: true,
              autoplay: {
            delay: 2500, 
            disableOnInteraction: false, 
            pauseOnMouseEnter: true, 
          },
          breakpoints: {
            150: { slidesPerView: 1.3, spaceBetween: 10 },
            576: { slidesPerView: 2.1, spaceBetween: 15 },
            769: { slidesPerView: 3.2, spaceBetween: 15 },
            1025: { slidesPerView: 3.9, spaceBetween: 20 },
          },
        });
      });
    });
  }, 1500)
});

}
document.addEventListener("DOMContentLoaded", function () {
    const MultipleSlider = () => {
        const MultipleSliders = document.querySelectorAll(".bannerSlider");
        MultipleSliders.forEach((slider, index) => {
            const prevArrow = slider.parentElement.querySelector(".prev");
            const nextArrow = slider.parentElement.querySelector(".next");
            new Swiper(slider, {
                direction: "horizontal",
                slidesPerView: 1,
                effect: "fade",
                speed: 1000,
                // allowTouchMove: false,
                navigation: {
                    nextEl: nextArrow,
                    prevEl: prevArrow,
                },
            });
        });
    };
    MultipleSlider();
});

document.addEventListener("DOMContentLoaded", function () {
    const MultipleSlider = () => {
        const MultipleSliders = document.querySelectorAll(".collectionSliderBundle");
        MultipleSliders.forEach((slider, index) => {
            const prevArrow = slider.parentElement.querySelector(".prev");
            const nextArrow = slider.parentElement.querySelector(".next");
            new Swiper(slider, {
                effect: 'slide',
                speed: 1000,
                // allowTouchMove: false,
                navigation: {
                    nextEl: nextArrow,
                    prevEl: prevArrow,
                },
                breakpoints: {
                    150: {
                        slidesPerView: 1.4,
                        spaceBetween: 10
                    },
                    576: {
                        slidesPerView: 2.5,
                        spaceBetween: 15,
                    },
                    769: {
                        slidesPerView: 3,
                        spaceBetween: 15,
                    },
                    1025: {
                        slidesPerView: 3,
                        spaceBetween: 20,
                    },
                },
            });
        });
    };
    MultipleSlider();
});

document.addEventListener("DOMContentLoaded", function () {
    const MultipleSlider = () => {
        const MultipleSliders = document.querySelectorAll(".collectionSlider");
        MultipleSliders.forEach((slider, index) => {
            const prevArrow = slider.parentElement.querySelector(".prev");
            const nextArrow = slider.parentElement.querySelector(".next");
            new Swiper(slider, {
                effect: 'slide',
                speed: 1000,
                // allowTouchMove: false,
                navigation: {
                    nextEl: nextArrow,
                    prevEl: prevArrow,
                },
                breakpoints: {
                    150: {
                        slidesPerView: 1.4,
                        spaceBetween: 10
                    },
                    576: {
                        slidesPerView: 2.5,
                        spaceBetween: 10
                    },
                    769: {
                        slidesPerView: 3,
                        spaceBetween: 10
                    },
                    1025: {
                        slidesPerView: 4,
                        spaceBetween: 10
                    },
                }
            });
        });
    };
    MultipleSlider();
});

document.addEventListener("DOMContentLoaded", function () {
    const MultipleSlider = () => {
        const MultipleSliders = document.querySelectorAll(".prodCardSlider");
        MultipleSliders.forEach((slider, index) => {
            const prevArrow = slider.parentElement.querySelector(".prev");
            const nextArrow = slider.parentElement.querySelector(".next");
            new Swiper(slider, {
                effect: 'slide',
                speed: 1000,
                // allowTouchMove: false,
                navigation: {
                    nextEl: nextArrow,
                    prevEl: prevArrow,
                },
                breakpoints: {
                    150: {
                        slidesPerView: 1.3,
                        spaceBetween: 10
                    },
                    576: {
                        slidesPerView: 2.5,
                        spaceBetween: 15
                    },
                    769: {
                        slidesPerView: 3,
                        spaceBetween: 20,
                    },
                    1025: {
                        slidesPerView: 4,
                        spaceBetween: 30
                    },
                }
            });
        });
    };
    MultipleSlider();
});

{
//     document.addEventListener("DOMContentLoaded", function () {
//     document.querySelectorAll(".womenResultSlider").forEach((slider, index) => {
//         const wrapper = slider.querySelector(".swiper-wrapper");
//         const slides = slider.querySelectorAll(".swiper-slide");
//         const clones = parseInt(slider.dataset.cloneMultiplier, 10) || 2;
//         for (let i = 0; i < clones; i++) {
//             slides.forEach((s) => wrapper.appendChild(s.cloneNode(true)));
//         }
//         console.log(
//             `Slider #${index + 1}: total slides ${wrapper.querySelectorAll(".swiper-slide").length
//             }`
//         );
//         new Swiper(slider, {
//             direction: "horizontal",
//             loop: true,
//             effect: 'slide',
//             speed: 1000,
//             centeredSlides: true,
//             grabCursor: true,
//             breakpoints: {
//                 150: { slidesPerView: 1.3, spaceBetween: 10 },
//                 576: { slidesPerView: 2.1, spaceBetween: 15 },
//                 769: { slidesPerView: 3.2, spaceBetween: 15 },
//                 1025: { slidesPerView: 3.9, spaceBetween: 20 },
//             },
//         });
//     });
// });


}


document.addEventListener('DOMContentLoaded', () =>{
   var swiper = new Swiper(".upsellSlider", {
      navigation: {
        nextEl: ".swiper-button-next.upsell-next",
        prevEl: ".swiper-button-prev.upsell-prev",
      },
    });
})


document.addEventListener("DOMContentLoaded", function () {
    const MultipleSlider = () => {
    const MultipleSliders = document.querySelectorAll(".megaMenuSlider");
    MultipleSliders.forEach((slider, index) => {
      new Swiper(slider, {
        direction: "horizontal",
        speed: 500,
        effect: "slide",
        grabCursor: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          1025: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
        },
      });
    });
  };
  MultipleSlider();
});

// {
//   document.addEventListener("DOMContentLoaded", function () {
//     const MultipleSlider = () => {
//       const MultipleSliders = document.querySelectorAll(".ProductS_slid");
//       MultipleSliders.forEach((slider, index) => {
//         const prevArrow = slider.parentElement.querySelector(".prev");
//         const nextArrow = slider.parentElement.querySelector(".next");
//         new Swiper(slider, {
//           direction: "horizontal",
//           loop: true,
//           speed: 1000,
//           autoplay: {
//             delay: 1000,
//             disableOnInteraction: false,
//           },
//           grabCursor: true,
//           navigation: {
//             nextEl: nextArrow,
//             prevEl: prevArrow,
//           },
//           breakpoints: {
//             150: {
//               slidesPerView: 1.3,
//               spaceBetween: 10,
//             },
//             576: {
//               slidesPerView: 2.1,
//               spaceBetween: 20,
//             },
//             769: {
//               slidesPerView: 2.7,
//               spaceBetween: 20,
//             },
//             1025: {
//               slidesPerView: 3,
//               spaceBetween: 30,
//             },
//             1150: {
//               slidesPerView: 4,
//               spaceBetween: 30,
//             },
//           },
//         });
//       });
//     };
//     MultipleSlider();
//   });
// }
